export { default } from "./IconRightButton";
